/**
 * High5 · Mobil dönüşüm — GİRİŞ GEREKTİRMEYEN paylaşım sayfası.
 *
 * platform.glowytics.com/p/<gizli-slug> — 12 Eki 2026'dan itibaren 6 slaytlık Apple tarzı
 * özet desteyi gösterir (Efe: "çok teferruatlı, özet olsun, apple style"). Ayrıntılı panel
 * raporu /r/high5-mobil-donusum'da kalır. Veri desteye gömülü, hiçbir uç çağrılmaz.
 * Slug: config/publicReportLinks.js → HIGH5_MOBIL_DONUSUM_SLUG. Gizlilik, erişim denetimi değil.
 */
import React, { useEffect } from 'react';
import High5MobilOzet from '../High5MobilOzet';

export default function High5MobilDonusumPublic() {
  useEffect(() => {
    // arama motoru dizinine girmesin, referrer sızmasın
    const metas = [['robots', 'noindex, nofollow, noarchive'], ['referrer', 'no-referrer']].map(([name, content]) => {
      const m = document.createElement('meta'); m.name = name; m.content = content; document.head.appendChild(m); return m;
    });
    const prevTitle = document.title;
    document.title = 'High5 · Mobil Dönüşüm';
    return () => { metas.forEach((m) => m.remove()); document.title = prevTitle; };
  }, []);

  return <High5MobilOzet />;
}
